// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Topbar container */
.topbar1 {
  display: flex;
  justify-content: space-between; /* Space between profile and icons */
  align-items: center; /* Vertically align items */
  height: 2.5%; /* Fixed height */

  padding: 20px; /* Horizontal padding */
  background-color: white;
  color: black;
  position: sticky; /* Sticky position */
  top: 2%; /* Ensure it stays below the Navbar */
  left: 0; /* Ensure it stays aligned to the left */
  right: 0; /* Ensure it stays aligned to the right */
  width: 100%; /* Ensure full width */
  flex-shrink: 0; /* Prevent shrinking */
  margin-left: -20%;

  /* margin-top: 6%; */
}

/* Profile section styling */
.profile-section {
  display: flex;
  align-items: center; /* Align profile items vertically */
  margin-left: 7%;
  margin-bottom: 1%;
}

.profile-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-left: -15%;
}

.profile-info {
  margin-left: 10%;

  gap: 5px;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
}
.profile-namedash {
  font-size: 16px;
  white-space: nowrap;
  font-weight: bold;
  display: inline-block;
  max-width: 100%;
}
.profile-designation {
  font-size: 14px;
  color: #777;
  margin-right: 30%;
  display: inline-block;
}

.icon-section {
  display: flex;
  gap: 40%;
  margin-right: 5%;
  font-size: 200%;
  margin-bottom: 2%;
}

.icon {
  font-size: 20px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.icon:hover {
  transform: scale(1.1);
}

.calendar-dropdown {
  position: absolute;
  top: 150px;
  right: 0.1%;
  font-size: small;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.close-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: #00468c;
  color: white;
  border: none;
  padding: 2% 3%;
  border-radius: 50%;
  cursor: pointer;
  font-size: small;
  z-index: 10;
}
.close-btn:hover {
  background: darkred;
}

/* Apply interactive effects to Font Awesome icons */
.fas.fa-calendar-alt,
.fas.fa-power-off {
  cursor: pointer;
  transition: transform 0.1s ease, color 0.3s ease;
}

/* Hover: scale up slightly and optionally change color */
.fas.fa-calendar-alt:hover,
.fas.fa-power-off:hover {
  transform: scale(1.1);
  color: #ffca28; /* adjust this color as desired */
}

/* Active: scale down slightly */
.fas.fa-calendar-alt:active,
.fas.fa-power-off:active {
  transform: scale(0.95);
}

/* Mobile view adjustments */
@media screen and (max-width: 768px) {
  .topbar1 {
    padding: 0px; /* Reduce padding */
    height: 15%; /* Allow height to adjust */
    margin-left: 0; /* Remove negative margin */
    flex-direction: column; /* Stack items vertically */
    align-items: center;
    margin-top: 0%;
    background-color: #001d4a;
  }

  .profile-section {
    flex-direction: column;
    text-align: left;
    margin-left: -30%;
    margin-top: 10%;
    z-index: 1000;
  }

  .profile-img {
    width: 50px;
    height: 50px;
    margin-right :140px; 
    
  }

  .profile-info {
    margin-left: 40px;
    
   
    margin-top: -40px;
    color: aliceblue;
  }

  .icon-section {
    position: absolute; /* Take it out of normal flow */
    top: 50px; /* Move it further upwards */
    right: 0%; /* Align it to the right */
    gap: 20px; /* Reduce space between icons */
    font-size: 120%; /* Reduce icon size */
    /* Make sure it's above everything */
    background: #001d4a; /* Optional: Prevent text overlap */
    padding: 5px; /* Adjust padding */
    color: aliceblue;
    border-radius: 5px; /* Smooth look */
  }

  .icon {
    font-size: 80%;
  }

  .calendar-dropdown {
    top: 0px; /* Adjust dropdown position */
    margin-top: 60%;
    font-size: small;
    margin-right: 2%;
    /* Make it more mobile-friendly */
  }

  .close-btn {
    font-size: 12px;
    padding: 5px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Topbar.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B,EAAE,oCAAoC;EACpE,mBAAmB,EAAE,2BAA2B;EAChD,YAAY,EAAE,iBAAiB;;EAE/B,aAAa,EAAE,uBAAuB;EACtC,uBAAuB;EACvB,YAAY;EACZ,gBAAgB,EAAE,oBAAoB;EACtC,OAAO,EAAE,qCAAqC;EAC9C,OAAO,EAAE,wCAAwC;EACjD,QAAQ,EAAE,yCAAyC;EACnD,WAAW,EAAE,sBAAsB;EACnC,cAAc,EAAE,sBAAsB;EACtC,iBAAiB;;EAEjB,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB,EAAE,mCAAmC;EACxD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;;EAEhB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;;EAEE,eAAe;EACf,gDAAgD;AAClD;;AAEA,yDAAyD;AACzD;;EAEE,qBAAqB;EACrB,cAAc,EAAE,iCAAiC;AACnD;;AAEA,gCAAgC;AAChC;;EAEE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE;IACE,YAAY,EAAE,mBAAmB;IACjC,WAAW,EAAE,2BAA2B;IACxC,cAAc,EAAE,2BAA2B;IAC3C,sBAAsB,EAAE,2BAA2B;IACnD,mBAAmB;IACnB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;;EAErB;;EAEA;IACE,iBAAiB;;;IAGjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB,EAAE,+BAA+B;IACnD,SAAS,EAAE,4BAA4B;IACvC,SAAS,EAAE,0BAA0B;IACrC,SAAS,EAAE,+BAA+B;IAC1C,eAAe,EAAE,qBAAqB;IACtC,oCAAoC;IACpC,mBAAmB,EAAE,mCAAmC;IACxD,YAAY,EAAE,mBAAmB;IACjC,gBAAgB;IAChB,kBAAkB,EAAE,gBAAgB;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ,EAAE,6BAA6B;IACvC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* Topbar container */\n.topbar1 {\n  display: flex;\n  justify-content: space-between; /* Space between profile and icons */\n  align-items: center; /* Vertically align items */\n  height: 2.5%; /* Fixed height */\n\n  padding: 20px; /* Horizontal padding */\n  background-color: white;\n  color: black;\n  position: sticky; /* Sticky position */\n  top: 2%; /* Ensure it stays below the Navbar */\n  left: 0; /* Ensure it stays aligned to the left */\n  right: 0; /* Ensure it stays aligned to the right */\n  width: 100%; /* Ensure full width */\n  flex-shrink: 0; /* Prevent shrinking */\n  margin-left: -20%;\n\n  /* margin-top: 6%; */\n}\n\n/* Profile section styling */\n.profile-section {\n  display: flex;\n  align-items: center; /* Align profile items vertically */\n  margin-left: 7%;\n  margin-bottom: 1%;\n}\n\n.profile-img {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin-left: -15%;\n}\n\n.profile-info {\n  margin-left: 10%;\n\n  gap: 5px;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: column;\n}\n.profile-namedash {\n  font-size: 16px;\n  white-space: nowrap;\n  font-weight: bold;\n  display: inline-block;\n  max-width: 100%;\n}\n.profile-designation {\n  font-size: 14px;\n  color: #777;\n  margin-right: 30%;\n  display: inline-block;\n}\n\n.icon-section {\n  display: flex;\n  gap: 40%;\n  margin-right: 5%;\n  font-size: 200%;\n  margin-bottom: 2%;\n}\n\n.icon {\n  font-size: 20px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.icon:hover {\n  transform: scale(1.1);\n}\n\n.calendar-dropdown {\n  position: absolute;\n  top: 150px;\n  right: 0.1%;\n  font-size: small;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.close-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: #00468c;\n  color: white;\n  border: none;\n  padding: 2% 3%;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: small;\n  z-index: 10;\n}\n.close-btn:hover {\n  background: darkred;\n}\n\n/* Apply interactive effects to Font Awesome icons */\n.fas.fa-calendar-alt,\n.fas.fa-power-off {\n  cursor: pointer;\n  transition: transform 0.1s ease, color 0.3s ease;\n}\n\n/* Hover: scale up slightly and optionally change color */\n.fas.fa-calendar-alt:hover,\n.fas.fa-power-off:hover {\n  transform: scale(1.1);\n  color: #ffca28; /* adjust this color as desired */\n}\n\n/* Active: scale down slightly */\n.fas.fa-calendar-alt:active,\n.fas.fa-power-off:active {\n  transform: scale(0.95);\n}\n\n/* Mobile view adjustments */\n@media screen and (max-width: 768px) {\n  .topbar1 {\n    padding: 0px; /* Reduce padding */\n    height: 15%; /* Allow height to adjust */\n    margin-left: 0; /* Remove negative margin */\n    flex-direction: column; /* Stack items vertically */\n    align-items: center;\n    margin-top: 0%;\n    background-color: #001d4a;\n  }\n\n  .profile-section {\n    flex-direction: column;\n    text-align: left;\n    margin-left: -30%;\n    margin-top: 10%;\n    z-index: 1000;\n  }\n\n  .profile-img {\n    width: 50px;\n    height: 50px;\n    margin-right :140px; \n    \n  }\n\n  .profile-info {\n    margin-left: 40px;\n    \n   \n    margin-top: -40px;\n    color: aliceblue;\n  }\n\n  .icon-section {\n    position: absolute; /* Take it out of normal flow */\n    top: 50px; /* Move it further upwards */\n    right: 0%; /* Align it to the right */\n    gap: 20px; /* Reduce space between icons */\n    font-size: 120%; /* Reduce icon size */\n    /* Make sure it's above everything */\n    background: #001d4a; /* Optional: Prevent text overlap */\n    padding: 5px; /* Adjust padding */\n    color: aliceblue;\n    border-radius: 5px; /* Smooth look */\n  }\n\n  .icon {\n    font-size: 80%;\n  }\n\n  .calendar-dropdown {\n    top: 0px; /* Adjust dropdown position */\n    margin-top: 60%;\n    font-size: small;\n    margin-right: 2%;\n    /* Make it more mobile-friendly */\n  }\n\n  .close-btn {\n    font-size: 12px;\n    padding: 5px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
